module.exports = __webpack_public_path__ + "img/whats-new-12_cn.0b44f12.jpg";